//import VirtualGuardHome from "@/components/virtualGuard/VirtualGuardHome.vue";

import VirtualGuard from "../../views/VirtualGuard.vue";




export default [
  {path: '/', component: VirtualGuard, name: 'root'}
]

